import React from 'react';

import 'shared/ui/CircularProgressIndicator/CircularProgressIndicator.css';

const CircularProgressIndicator = ({ loading, msg = null }) => {
  return (
    <div className={`loading-overlay ${loading ? 'show' : ''}`}>
      <div className="loading-spinner"></div>
      <div className="msg">{msg}</div>
    </div>
  );
};

export default CircularProgressIndicator;
